import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-ac-variants-coverages-row-title',
  templateUrl: './ac-variants-coverages-row-title.component.html',
  styleUrls: ['./ac-variants-coverages-row-title.component.scss']
})
export class AcVariantsCoveragesRowTitleComponent implements OnInit {

  @Input() title: string | boolean;
  @Input() tooltip: string = null;

  constructor() { }

  ngOnInit() {
  }

}
